<mat-slide-toggle class="example-margin" [(ngModel)]="model" [color]="color" [checked]="checked" [disabled]="false" [required]="required">
{{label}}
</mat-slide-toggle>